module.exports = __webpack_public_path__ + "static/media/errorStepper.244a4b8b.svg";